<template>
    <div class="pagination_wrapper">
        <div class="flex w-full justify-between">
            <div>
                <span class="main-text-color">
                    {{ $t('general.pages') }}:
                </span>
                <el-dropdown class="pagination-dropdown" placement="top-end" trigger="click" @command="onPageSelect" :disabled="!totalPages.length || totalPages.length === 1">
                    <span class="el-dropdown-link mx-2 flex items-center">
                        <span class="current-page-number main-text-color">
                            {{ currentPage }}
                        </span>
                        <i class="vc-icon-down text-xl text-primary"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="max-h-48 overflow-y-auto">
                        <el-dropdown-item
                            v-for="item in totalPages"
                            :key="item"
                            :command="item">
                            {{ item }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="flex">
                <span class="main-text-color font-bold">{{ paginationFrom }} - {{ paginationTo }}</span>
                <span class="main-text-color mx-2">of</span>
                <span class="main-text-color font-bold">{{ paginationTotal }}</span>
                <div class="mx-6">
                    <span
                        @click="goToPrevPage"
                        :class="paginationFrom === 1 || paginationFrom === 0 ? 'opacity-80 cursor-not-allowed' : 'cursor-pointer'"
                    >
                        <i class="vc-icon-left icon-lg text-primary mr-2" />
                    </span>
                    <span
                        @click="goToNextPage"
                        :class="paginationTo === paginationTotal ? 'opacity-80 cursor-not-allowed' : 'cursor-pointer'"
                    >
                        <i class="vc-icon-right icon-lg text-primary ml-2" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Dropdown, DropdownMenu, DropdownItem} from 'element-ui'

export default {
    name: "table-pagination",
    components: {
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,

    },
    props: {
        currentPage: {
            type: Number,
        },
        totalPages: {
            type: Array,
        },
        paginationFrom: {
            type: Number,
        },
        paginationTo: {
            type: Number,
        },
        paginationTotal: {
            type: Number,
        },
    },
    methods: {
        goToPrevPage() {
            this.$emit('go-to-prev-page')
        },
        goToNextPage() {
            this.$emit('go-to-next-page')
        },
        onPageSelect(page) {
            this.$emit('on-page-select', page)
        }
    }
}
</script>

<style scoped lang="scss">
.pagination_wrapper {
    @apply p-4 rounded-b-1xl;
    border: 1px solid var(--gray-300);
    border-top: 0;
    background: var(--mainBgColor-color);
}
[dir="ltr"] .current-page-number {
    @apply mr-1;
}
[dir="rtl"] .current-page-number {
    @apply ml-1;
}
::v-deep .popper__arrow {
    display: none !important;
}
</style>
